import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { MusicPlayer } from "@/components/site/music/MusicPlayer";
import Home from "@/pages/Home";
import ProjectPage from "@/pages/ProjectPage";
import WebtoonPage from "@/pages/WebtoonPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project/:id" element={<ProjectPage />} />
            <Route path="/webtoon/:id" element={<WebtoonPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          <MusicPlayer />
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#12131A",
              border: "1px solid rgba(245,165,36,.5)",
              color: "#F3F4F6",
              borderRadius: 0,
              fontFamily: "JetBrains Mono, monospace",
              fontSize: 12,
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
